import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
// import CalenderPage from "./CalenderPage";

// End

// const label = { inputProps: { "aria-label": "Size switch demo" } };

function BookAmenitiesCalender() {
  // const navigate = useNavigate();

  const [value, setValue] = React.useState(dayjs("2014-08-18T21:11:54"));

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  // For memu
  // const [, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose2 = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");
  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid
          container
          spacing={3}
          className="mainHeadingLine AmenitiesOuterMain"
        >
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Book Amenities</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="">
                <div className="bookAmiListNewInner">
                  <div className="booksBtnsMain">
                    <Button className="booksBt booksBtActive">
                      Club House
                    </Button>
                    <Button className="booksBt">Swimming Pool</Button>
                    <Button className="booksBt">
                      Library & Computerized Study Center
                    </Button>
                    <Button className="booksBt">Personal Spa</Button>
                    <Button className="booksBt">Swimming Pool</Button>
                    <Button className="booksBt">Indoor Basketball Court</Button>
                    <Button className="booksBt">Yoga & Meditation Deck</Button>
                    <Button className="booksBt">Personal Spa</Button>
                    <Button className="booksBt">Swimming Pool</Button>
                  </div>
                  <div className="calenderMain">
                    <h2 className="amiHeading">Club House</h2>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <div className="visitCont2">
                          <div className="visitBottCont">
                            <p>Capacity:</p>
                            <b>20-60 People</b>
                          </div>
                          <div className="visitBottCont">
                            <p>Charges:</p>
                            <b>Rs 1000/-</b>
                            <span>per hour</span>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <div className="targetIndict">
                          <div className="targetIndictInr">
                            <span style={{ background: "#08AE36" }}></span>
                            <em>Booked</em>
                          </div>
                          <div className="targetIndictInr">
                            <span></span>
                            <em>Available</em>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="calenderDiv">
                          {/* <CalenderPage /> */}
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="calDateSelect dateTimeMain">
                          <label>Select Date</label>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack className="inputForDate">
                              <DesktopDatePicker
                                inputFormat="MM/DD/YYYY"
                                value={value}
                                onChange={handleChange}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div className="calDateSelect">
                          <label>Select Timeslot</label>
                          <Button className="timeSlot">
                            07:00am To 11:30am
                          </Button>
                          <Button className="timeSlot timeSlotAcive">
                            12:00pm To 3:30pm
                          </Button>
                          <Button className="timeSlot timeSlotAcive">
                            12:00pm To 3:30pm
                          </Button>
                          <Button className="timeSlot">
                            07:00am To 11:30am
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={12}>
                        <Button className="addBt">Book</Button>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default BookAmenitiesCalender;
